// @ts-nocheck
'use strict';

/** @param {HTMLElement} rootElem */
function DealerBusinessCard(rootElem) {
    if (! (rootElem instanceof HTMLElement)) {
        throw new Error('expected root elem to be of type HTMLElement');
    }
    this.rootElem = rootElem;
}

DealerBusinessCard.prototype = {
    setup: function () {
        // First: the gallery hides its scrollbar, so it must get its arrows even if a
        // later step throws.
        this.setupShopGallery();
        this.handleImprint();
        this.setupCarousel();
        this.setupNavigationAnimation();
        this.setupStickyHeader();
        this.setTitle();
        this.handleTosLink();
        this.setupOrderForm();
        this.setupDownloads();
    },
    /**
     * "Unser Shop" gallery: the row scrolls natively (swipe, snap) with its scrollbar
     * hidden; the two arrows move it by one tile. They only show when the tiles do
     * not fit, and each one is disabled at its end of the row.
     */
    setupShopGallery: function () {
        const gallery = this.rootElem.querySelector('.dealerShop__gallery');
        const nav = this.rootElem.querySelector('.js-dealerShopNav');

        if (! gallery || ! nav) {
            return;
        }

        const prev = nav.querySelector('.js-dealerShopPrev');
        const next = nav.querySelector('.js-dealerShopNext');

        const update = () => {
            const maxScroll = gallery.scrollWidth - gallery.clientWidth;
            // 1px tolerance: scrollLeft is fractional on scaled displays.
            nav.hidden = maxScroll <= 1;
            prev.disabled = gallery.scrollLeft <= 1;
            next.disabled = gallery.scrollLeft >= maxScroll - 1;
        };

        const scrollByTile = direction => {
            const tile = gallery.querySelector('.dealerShop__tile');
            const gap = parseFloat(getComputedStyle(gallery).columnGap) || 0;
            const step = tile ? tile.getBoundingClientRect().width + gap : gallery.clientWidth;
            gallery.scrollBy({ left: direction * step, behavior: 'smooth' });
        };

        prev.addEventListener('click', () => scrollByTile(-1));
        next.addEventListener('click', () => scrollByTile(1));
        gallery.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
    },
    /**
     * Phone view of the downloads panel: the partner's link list is collapsed behind
     * "Alle Downloads" (design 2289:837). From @screen-md up the css shows the list and
     * hides the toggle, so nothing here has to run per breakpoint.
     */
    setupDownloads: function () {
        const toggle = this.rootElem.querySelector('.js-dealerDownloadsToggle');
        const links = this.rootElem.querySelector('.js-dealerDownloadsLinks');

        if (! toggle || ! links) {
            return;
        }

        toggle.addEventListener('click', () => {
            const expanded = links.classList.toggle('dealerDownloads__links--expanded');
            toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        });
    },
    setupCarousel: function () {
        const searchInput = document.getElementById('js-searchTeamInput');
        const searchInputButton = document.getElementById('js-searchTeamButton');
        const prevButton = document.getElementById('js-teamsPrev');
        const nextButton = document.getElementById('js-teamsNext');
        const hiddenItems = document.getElementById('scrollbarTeamsHidden');
        const scrollbarWrapper = document.getElementById('scrollbarTeams');

        function generateScrollbar() {
            let itemsXS = 2;
            let itemsSM = 3;
            let itemsMD = 4;
            let itemsLG = 5;
            let scrollbar = $('#scrollbarTeams');

            if (itemsLG < itemsMD) {
                itemsMD = itemsLG;
            }

            if (itemsLG < itemsSM) {
                itemsSM = itemsLG;
            }

            if (itemsLG < itemsXS) {
                itemsXS = itemsLG;
            }

            scrollbar.owlCarousel({
                loop: true,
                margin: 10,
                nav: false,
                dots: false,
                autoplay: true,
                autoHeight: true,
                autoWidth: false,
                navText: ['<i class="icon icon-angle-left"></i>', '<i class="icon icon-angle-right"></i>'],
                autoplayHoverPause: true,
                center: true,
                autoPlay: 2500,
                autoplaySpeed: 1000,
                navSpeed: 1000,
                responsive: {
                    0: {
                        items: itemsXS,
                    },
                    768: {
                        items: itemsSM,
                    },
                    1024: {
                        items: itemsMD,
                    },
                    1250: {
                        items: itemsLG,
                    },
                },
            });

            return scrollbar;
        }

        function filterScrollbar(scrollbarItems,value) {
            scrollbar.owlCarousel('destroy');
            let valueSearch = value.toLowerCase();
            for(let item of scrollbarItems) {
                let searchText = item.dataset.searchText.toLowerCase();
                if(! searchText.includes(valueSearch)) {
                    hiddenItems.appendChild(item);
                }
            }
            for(let item of hiddenItems.querySelectorAll('.scrollbar__item')) {
                let searchText = item.dataset.searchText.toLowerCase();
                if(searchText.includes(valueSearch)) {
                    scrollbarWrapper.appendChild(item);
                }
            }
            return generateScrollbar();
        }

        let scrollbar = generateScrollbar();

        // The arrow buttons replace the former "Zum Teamshop" button. `scrollbar` is reassigned
        // whenever the search rebuilds the carousel, so the handlers always steer the live one.
        if (prevButton) {
            prevButton.addEventListener('click', () => scrollbar.trigger('prev.owl.carousel'));
        }
        if (nextButton) {
            nextButton.addEventListener('click', () => scrollbar.trigger('next.owl.carousel'));
        }

        if(searchInput && searchInputButton) {
            if(scrollbar) {
                const scrollbarItems = scrollbar[0].querySelectorAll('.scrollbar__item');
                if(scrollbarItems) {
                    searchInputButton.addEventListener('click',function () {
                        scrollbar = filterScrollbar(scrollbarItems,searchInput.value);
                    });
                    searchInput.addEventListener('keyup',function (e) {
                        if(e.key === 'Enter' || e.keyCode === 13) {
                            scrollbar = filterScrollbar(scrollbarItems,searchInput.value);
                        }
                    });
                }
            }
        }
    },
    setupStickyHeader: function () {
        const mn = $('.headerDealerCard');
        const mns = 'sticky';
        const hdr = 0;

        checkSticky(mn, mns, hdr);

        window.addEventListener('scroll', () => checkSticky(mn, mns, hdr));
        window.addEventListener('resize', () => checkSticky(mn, mns, hdr));
    },
    setupNavigationAnimation: function () {
        $('.headerDealerCardNavigation a[href^="#"]').on('click', function onNavClick(e) {
            var href = $(this).attr('href');
            if ($(href).length > 0) {
                var top = $(href).offset().top;
                var heightHeader = $('.headerDealerCard').outerHeight();
                $('html,body').animate({
                    scrollTop: top - heightHeader,
                }, 800);
                e.preventDefault();
            }
        });
    },
    setTitle: function () {
        const dataElem = document.getElementById('js-googleData');
        if (dataElem.dataset.title) {
            document.title = dataElem.dataset.title;
        }
    },
    handleTosLink: function () {
        let customTosLink = this.rootElem.dataset.customTosLink;
        if (typeof customTosLink !== 'string') {
            return;
        }
        customTosLink = customTosLink.trim();
        if (! customTosLink) {
            return;
        }
        const footer = document.querySelector('.footerBottom .footerBottomNavigation');
        const footerAnchors = footer.getElementsByTagName('a');
        const pathRegex = new RegExp('^.*/(agb|general-terms)/?$');
        // eslint-disable-next-line no-useless-escape
        const hostnameRegex = new RegExp('^(www\.)?(jako\.(com|de)|.*dc-test\.de)$');
        for (const anchor of footerAnchors) {
            const url = new URL(anchor.href);
            if (hostnameRegex.test(url.hostname) && pathRegex.test(url.pathname)) {
                anchor.href = customTosLink;
                break;
            }
        }
    },
    /**
     * The order form (requirement 10): the article number searches the catalogue from the third
     * character on, the answer fills the colour and size lists of its block, and the player resp.
     * size rows are added and removed on the spot. The article groups start collapsed and
     * open on their header.
     */
    setupOrderForm: function () {
        const form = document.querySelector('.dealerOrder__form');
        if (! form) {
            return;
        }

        const minChars = Number(form.dataset.minSearchChars) || 3;
        const searchUrl = new URL(window.location.href);
        searchUrl.searchParams.set('bus_card_action', 'item_search');

        form.querySelectorAll('.dealerOrder__group').forEach((group) => {
            const toggle = group.querySelector('.js-orderGroupToggle');
            const body = group.querySelector('.js-orderGroupBody');
            const rows = group.querySelector('.js-orderRows');
            const template = group.querySelector('.js-orderRowTemplate');
            const addButton = group.querySelector('.js-orderAddRow');
            const articleInput = group.querySelector('.js-orderArticleNo');
            const suggestions = group.querySelector('.js-orderSuggestions');
            const colorSelect = group.querySelector('.js-orderColor');
            const colorLabel = group.querySelector('.js-orderColorLabel');
            const printOptions = group.querySelector('.js-orderPrintOptions');
            let sizes = [];
            let timer = null;

            const addRow = () => {
                const row = template.content.firstElementChild.cloneNode(true);
                const sizeSelect = row.querySelector('.js-orderSize');
                if (sizeSelect) {
                    fillOptions(sizeSelect, sizes);
                }
                row.querySelector('.js-orderRemoveRow').addEventListener('click', () => row.remove());
                rows.appendChild(row);
            };

            const fillOptions = (select, entries) => {
                const selected = select.value;
                select.innerHTML = '<option value=""></option>';
                entries.forEach((entry) => {
                    const option = document.createElement('option');
                    option.value = entry.code;
                    option.textContent = entry.label || entry.code;
                    select.appendChild(option);
                });
                select.value = selected;
            };

            const applyItem = (item) => {
                articleInput.value = item.itemNo2 || item.itemNo;
                fillOptions(colorSelect, item.colors);
                sizes = item.sizes;
                rows.querySelectorAll('.js-orderSize').forEach((select) => fillOptions(select, sizes));

                // Blocks that cannot be finished (socks) have no print colour field.
                if (printOptions) {
                    printOptions.innerHTML = '';
                    const printColors = [...new Set(item.colors.map((color) => color.printColor).filter(Boolean))];
                    printColors.forEach((printColor) => {
                        const option = document.createElement('option');
                        option.value = printColor;
                        printOptions.appendChild(option);
                    });
                }

                suggestions.classList.add('hidden');
                suggestions.innerHTML = '';
            };

            const search = async (query) => {
                searchUrl.searchParams.set('q', query);
                try {
                    const response = await fetch(searchUrl.toString(), {
                        headers: { Accept: 'application/json' },
                    });
                    if (! response.ok) {
                        return;
                    }
                    const data = await response.json();
                    suggestions.innerHTML = '';
                    (data.items || []).forEach((item) => {
                        const entry = document.createElement('li');
                        entry.textContent = `${item.itemNo2} - ${item.description}`;
                        entry.addEventListener('click', () => applyItem(item));
                        suggestions.appendChild(entry);
                    });
                    suggestions.classList.toggle('hidden', suggestions.childElementCount === 0);
                } catch (error) {
                    suggestions.classList.add('hidden');
                }
            };

            articleInput.addEventListener('input', () => {
                const query = articleInput.value.trim();
                window.clearTimeout(timer);
                if (query.length < minChars) {
                    suggestions.classList.add('hidden');
                    return;
                }
                // One request per pause in typing instead of one per keystroke.
                timer = window.setTimeout(() => search(query), 250);
            });

            articleInput.addEventListener('blur', () => {
                window.setTimeout(() => suggestions.classList.add('hidden'), 200);
            });

            colorSelect.addEventListener('change', () => {
                colorLabel.value = colorSelect.options[colorSelect.selectedIndex].textContent.trim();
            });

            // Each group opens on its own: a club usually orders several of them.
            toggle.addEventListener('click', () => {
                const expanded = toggle.getAttribute('aria-expanded') !== 'true';
                toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
                body.hidden = ! expanded;
            });

            addButton.addEventListener('click', addRow);
            addRow();
        });
    },
    handleImprint() {
        const modalImprint = '#modalImprint';
        if (document.querySelectorAll(modalImprint).length !== 1) {
            return;
        }
        document.querySelectorAll('.js-navigation_imprint').forEach((item) => {
            item.removeAttribute('href');
            item.addEventListener('click', () => {
                jQuery(modalImprint).modal();
            });
        });
    }
};

window.addEventListener('load', () => {
    const rootElem = document.getElementById('dealerBusinessCard');
    const dealerBusCard = new DealerBusinessCard(rootElem);
    dealerBusCard.setup();
});

$('.team-carousel').owlCarousel({
    loop: true,
    center: true,
    autoWidth: true,
    nav: true,
    dots: false,
    navText: ['<i class="icon icon-arrow-left"></i>', '<i class="icon icon-arrow-right"></i>'],
    margin: 0,
    responsiveClass: true,
    items: 1,
});
